var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("p", [_vm._v("Loading...")])
      : _c(
          "div",
          [
            _c("file-manager-component", {
              attrs: {
                createData: _vm.createAsset,
                updateBatch: _vm.updateAssets,
                allowedExtensions: _vm.schema.file.extensions,
                content: _vm.assets
              },
              on: {
                "fm::asset::select": _vm.selectAsset,
                "fm::asset::dblclick": _vm.addAsset
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bcae7e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bcae7e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/FileFormComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4bcae7e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/FileFormComponent.vue
// module chunks = 0